import type { RouteRecordRaw } from 'vue-router'
import { AppRoute } from '@/constants'
import { ModuleAccess } from '@/constants/rights'

export const ProcessInstanceRoutes: RouteRecordRaw[] = [
  {
    path: AppRoute.ProcessInstance.path,
    name: AppRoute.ProcessInstance.name,
    component: () => import('@/modules/process-instance/Index.vue'),
    meta: {
      requiresAuth: true,
      authorities: [ModuleAccess],
    },
  },
  {
    path: AppRoute.ProcessInstance.Page.path,
    name: AppRoute.ProcessInstance.Page.name,
    component: () => import('@/modules/process-instance/page/Index.vue'),
    redirect: { name: AppRoute.ProcessInstance.Page.Main.name },
    props: true,
    meta: {
      requiresAuth: true,
      authorities: [ModuleAccess],
    },
    children: [
      {
        path: AppRoute.ProcessInstance.Page.Main.path,
        name: AppRoute.ProcessInstance.Page.Main.name,
        component: () => import('@/modules/process-instance/page/MainInfo.vue'),
      },
      {
        path: AppRoute.ProcessInstance.Page.Process.path,
        name: AppRoute.ProcessInstance.Page.Process.name,
        component: () => import('@/modules/process-instance/page/VersionInfo.vue'),
      },
      {
        path: AppRoute.ProcessInstance.Page.Task.path,
        name: AppRoute.ProcessInstance.Page.Task.name,
        component: () => import('@/modules/process-task/components/Table.vue'),
      },
      {
        path: AppRoute.ProcessInstance.Page.SubInstances.path,
        name: AppRoute.ProcessInstance.Page.SubInstances.name,
        component: () => import('@/modules/process-instance/components/Table.vue'),
      },
    ],
  },
]
